"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.sortRecipesByField = exports.fieldToSortByOptions = exports.useRecipeListSortBy = exports.fieldToSortByToLabel = exports.fieldToSortByParam = void 0;
const zustand_1 = __importDefault(require("zustand"));
const common_1 = require("@saffron/common");
exports.fieldToSortByParam = {
    name: (r) => r.name.toLowerCase(),
    rating: (r) => -(r.rating || -1),
    createdAt: "createdAt",
};
exports.fieldToSortByToLabel = {
    name: "A-Z",
    rating: "Rating",
    createdAt: "Recent",
};
exports.useRecipeListSortBy = zustand_1.default(set => ({
    fieldToSortBy: "name",
    setFieldToSortBy: fieldToSortBy => set({ fieldToSortBy }),
}));
exports.fieldToSortByOptions = [
    { label: "Alphabetical", value: "name" },
    { label: "Recent", value: "createdAt" },
    { label: "Rating", value: "rating" },
];
exports.sortRecipesByField = (recipes, field) => {
    const sortedRecipes = common_1.sortBy(recipes, exports.fieldToSortByParam[field]);
    if (field === "createdAt") {
        sortedRecipes.reverse();
    }
    return sortedRecipes;
};
//# sourceMappingURL=RecipeListSortByStore.js.map